import React from "react";

const CPP_Recursion = () => {
  return (
    <div>
      <h1>CPP_Recursion Component</h1>
      <p>Content for CPP_Recursion goes here...</p>
    </div>
  );
};

export default CPP_Recursion;
